import { Routes } from '@angular/router';
import { AdminGuard } from '@curbnturf/auth';
import { AdminLayoutComponent } from './components/ui-admin/admin-layout/admin-layout.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./components/site-admin/site-admin.route').then((m) => m.SITE_ADMIN_ROUTES),
  },
  {
    path: 'sites',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./components/site-admin/site-admin.route').then((m) => m.SITE_ADMIN_ROUTES),
  },
  {
    path: 'pois',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        loadComponent: () => import('./components/poi-admin/pois/pois.component').then((mod) => mod.PoisComponent),
      },
    ],
  },
  {
    path: 'reservations',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import('./components/reservation-admin/reservation-admin.route').then((m) => m.RESERVATION_ADMIN_ROUTES),
  },
  {
    path: 'users',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./components/user-admin/user-admin.route').then((m) => m.USER_ADMIN_ROUTES),
  },
  {
    path: 'auth',
    loadChildren: () => import('@curbnturf/auth-components/src/lib/auth.route').then((mod) => mod.AUTH_ROUTES),
  },
  {
    path: 'listings',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('@curbnturf/listing-edit/src/lib/listing.route').then((mod) => mod.LISTINGS_ROUTES),
  },
  {
    path: 'properties',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('@curbnturf/listing-edit/src/lib/listing.route').then((mod) => mod.LISTINGS_ROUTES),
  },
  {
    path: 'email-template',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./components/email-admin/email-admin.routes').then((m) => m.EMAIL_ADMIN_ROUTE),
  },
  {
    path: 'affiliates',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    loadChildren: () =>
      import('./components/affiliate-admin/affiliate-admin-routing').then((m) => m.AFFILIATE_ADMIN_ROUTES),
  },
  {
    path: 'rating',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    loadChildren: () => import('./components/rating-admin/rating-admin.route').then((mod) => mod.RATING_ADMIN_ROUTES),
  },
  {
    path: 'log',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    loadChildren: () => import('./components/log-admin/log-admin.route').then((m) => m.LOG_ADMIN_ROUTES),
  },
  {
    path: 'search',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./components/search-admin/search/search.component').then((m) => m.SearchComponent),
      },
    ],
  },
  {
    path: 'reports',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/reports-admin/weekly/weekly.component').then((m) => m.WeeklyComponent),
      },
    ],
  },
  {
    path: 'articles',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./components/article-admin/article-admin.route').then((m) => m.ARTICLE_ROUTES),
  },
  {
    path: 'payouts',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/user-admin/payouts/payouts.component').then((m) => m.PayoutsComponent),
      },
    ],
  },
  {
    path: 'address-filtering',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/address-filtering/address-filtering.component').then((m) => m.AddressFilteringComponent),
      },
    ],
  },
  { path: '**', redirectTo: '/' },
];
